export default "__VITE_ASSET__BqpJCtqu__"